import m from "mithril";
import i18n from "../i18n/i18n";
import {UnitTypes} from "../../admin/values";

export const EnrolmentStatus = Object.freeze({
    NOT_STARTED: "not_started",
    PASSED: "passed",
    FAILED: "failed",
    ARCHIVED: "archived",
    IN_PROGRESS: "in_progress",
    CANCELLED: "cancelled",         // Used for Unit Enrolments
    UN_ARCHIVED: "un_archived",     // Not a status but used as a constant where other statuses are
})

export function getCourseEnrolmentStatus(enr, adminView, loading){
    if(!loading) {
        let courseStatusResult= adminView ? enr.properties : enr;
        if(enr) {
            const labelClass = courseStatusResult.isArchived ? "label-info" : null;
            if (courseStatusResult.isCompleted && courseStatusResult.isPassed) {
                return m(".label-circle " + (labelClass || "label-success"), i18n.t("passed"));
            } else if (courseStatusResult.isCompleted && !courseStatusResult.isPassed) {
                return m(".label-circle " + (labelClass || "label-error"), i18n.t("failed"));
            } else if (courseStatusResult.isStarted) {
                return m(".label-circle " + (labelClass || "label-warning"), i18n.t("in_progress"));
            } else {
                return m(".label-circle" + (labelClass ? " " + labelClass : ""), i18n.t("not_started"));
            }
        }
    }

    if(loading) {
        return m(".text-gray", [i18n.t("loading"), m(".loading-dots")]);
    }

}

export function getUnitStatus(unit){

    if (unit.loading) {
        return m('.unit-status-icon loading', m('i'));
    }

    if (unit.type === UnitTypes.approval && unit.enrolment) {
        if (unit.enrolment.isPassed) {
            return m('.unit-status-icon passed', m('i.icon-check'));
        }
        else if (unit.enrolment.isViewed) {
            return m('.unit-status-icon warn', { title: i18n.t("viewed") }, m('i.icon-visible'));
        } else if (unit.enrolment.submitted) {
            return m('.unit-status-icon warn', { title: i18n.t("pending_approval") }, m('i.icon-clock'));
        }
        else if(unit.enrolment.isCompleted && !unit.enrolment.isPassed){
            return m('.unit-status-icon warn', m('i.icon-clock'));
        }
    }

    if (unit.type === UnitTypes.assessment && unit.enrolment) {
        if (unit.enrolment.isPassed) {
            return m('.unit-status-icon passed', m('i.icon-check'));
        }
        else if (unit.enrolment.assessmentSubmitted) {
            return m('.unit-status-icon warn', { title: i18n.t("pending_approval") }, m('i.icon-clock'));
        }
        else if(unit.enrolment.isCompleted && !unit.enrolment.isPassed){
            return m('.unit-status-icon warn', m('i.icon-clock'));
        }
    }

    if (unit.type === UnitTypes.scorm && unit.enrolment && unit.enrolment.isStarted && !unit.enrolment.isCompleted) {
        return m('.unit-status-icon warn', { title: i18n.t("in_progress") }, m('i.icon-clock'));
    }

    if (unit.enrolment && unit.enrolment.isCompleted) {
        if (unit.enrolment.isPassed) {
            return m('.unit-status-icon passed', m('i.icon-check'));
        } else {
            return m('.unit-status-icon failed', m('i.icon-x'));
        }
    }

    return '';
}

export const createOption = (textKey, callback, param, param2) =>
    m("div", { onclick: () => callback(param, textKey, param2) }, i18n.t(textKey));

/**
 * Calculates the expiry date for a course enrolment based on completion date and expiry days
 * @param {Object} course - Course object with selfEnrolmentExpires, selfEnrolmentExpiryDays
 * @param {Object} enrolment - Enrolment object with completionDate (optional, can be in course.enrolment)
 * @returns {string|null} ISO string of expiry date or null if cannot be calculated
 */
export function calculateCourseExpiry(course, enrolment = null) {
    const enrol = enrolment || course?.enrolment;
    if (!course?.selfEnrolmentExpires || !enrol?.completionDate || course?.selfEnrolmentExpiryDays == null ) {
        return null;
    }

    const completionDate = new Date(enrol.completionDate);
    const expiryDate = new Date(completionDate);
    expiryDate.setDate(expiryDate.getDate() + course.selfEnrolmentExpiryDays);

    return expiryDate.toISOString();
}

/**
 * Checks if a course enrolment has expired
 * @param {Object} course - Course object with selfEnrolmentExpires, selfEnrolmentExpiryDays
 * @param {Object} enrolment - Enrolment object with completionDate (optional, can be in course.enrolment)
 * @returns {boolean} True if expired, false otherwise
 */
export function isCourseExpired(course, enrolment = null) {
    const expiryDate = calculateCourseExpiry(course, enrolment);
    if (!expiryDate) {
        return false;
    }

    const now = new Date();
    const expiry = new Date(expiryDate);
    return now > expiry;
}
